export interface ZusPodatkiAgregat {
  razem: ZusPodatki[];
  wlasciciele: ZusPodatki[];
  pracownicy: ZusPodatki[];
}

export interface ZusPodatki {
  liczbaPorzadkowa: number;
  kwota: number;
  okres: string;
  rodzaj: string;
  uwagi: string;
  terminPlatnosci: Date;
  typ: Typ;
}

export enum Typ {
  ZUS = 'ZUS',
  PODATKI = 'PODATKI'
}
